enum IntegrationStatus {
  UNLINKED = 'unlinked',
  LOADING = 'loading',
  LINKED = 'linked',
}
export { IntegrationStatus };
